import { render, staticRenderFns } from "./LearnPortalLink.vue?vue&type=template&id=0cbe7fd8"
import script from "./LearnPortalLink.vue?vue&type=script&lang=js"
export * from "./LearnPortalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports